import styled from 'styled-components';

import {FilterContent} from 'components/ui-kit/Table2.0/HeaderWrapper/Filtration/styled';
import {colors} from 'theme';

export const PageContent = styled.div`
    min-height: calc(100vh - 125px);
`;

export const Toolbar = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    width: 100%;

    & > button {
        width: auto;
    }
`;

export const ExportFields = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

export const ExportPopoverAnchor = styled.div`
    > button {
        width: auto;
    }
`;

export const ExportFilterContent = styled(FilterContent)`
    width: 440px;
`;

export const EventId = styled.span`
    color: ${colors.brandPrimary};
    word-break: break-all;
`;

export const BreakAllValue = styled.span`
    word-break: break-all;
`;

export const DetailCard = styled.div`
    max-width: 900px;
    padding: 24px;
    border-radius: 8px;
    background: ${colors.white};
`;

export const DetailHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    padding-bottom: 18px;
    border-bottom: 1px solid ${colors.border};
`;

export const DetailTitle = styled.h1`
    margin: 0 0 5px;
    color: ${colors.darkGrey};
    font-size: 18px;
    line-height: 24px;
`;

export const DetailId = styled.div`
    color: ${colors.textSecondary};
    font-family: 'JetBrains Mono', monospace;
    font-size: 12px;
`;

export const DetailHeaderActions = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const Section = styled.section`
    padding: 20px 0;
    border-bottom: 1px solid ${colors.border};

    &:last-child {
        padding-bottom: 0;
        border-bottom: 0;
    }
`;

export const SectionTitle = styled.h2`
    margin: 0 0 16px;
    color: ${colors.brandPrimary};
    font-size: 13px;
    line-height: 18px;
    text-transform: uppercase;
`;

export const FieldsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 16px 24px;

    @media (max-width: 900px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
`;

export const Field = styled.div<{wide?: boolean}>`
    grid-column: ${(p) => (p.wide ? '1 / -1' : 'auto')};
    min-width: 0;
`;

export const FieldLabel = styled.div`
    margin-bottom: 4px;
    color: ${colors.textSecondary};
    font-size: 12px;
    line-height: 16px;
`;

export const FieldValue = styled.div<{$mono?: boolean}>`
    color: ${colors.darkGrey};
    font-family: ${(p) => (p.$mono ? "'JetBrains Mono', monospace" : 'inherit')};
    font-size: 14px;
    line-height: 20px;
    overflow-wrap: anywhere;
`;

export const CountsTable = styled.div`
    overflow: hidden;
    border: 1px solid ${colors.border};
    border-radius: 8px;
`;

export const CountRow = styled.div<{header?: boolean}>`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    padding: ${(p) => (p.header ? '10px 16px' : '12px 16px')};
    border-bottom: 1px solid ${colors.border};
    background: ${(p) => (p.header ? colors.background : colors.white)};
    color: ${(p) => (p.header ? colors.textSecondary : colors.darkGrey)};
    font-size: ${(p) => (p.header ? '12px' : '14px')};

    &:last-child {
        border-bottom: 0;
    }

    > :last-child {
        text-align: right;
    }
`;

export const StatusesGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(4, minmax(130px, 1fr));
    gap: 10px;
`;

export const StatusItem = styled.div<{color: string}>`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 9px 14px;
    border: 1px solid ${(p) => `${p.color}30`};
    border-radius: 8px;
    background: ${(p) => `${p.color}0d`};
    font-size: 13px;

    &:before {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: ${(p) => p.color};
        content: '';
    }

    > :last-child {
        margin-left: auto;
        color: ${(p) => p.color};
        font-weight: 600;
    }
`;

export const EmptyDetail = styled.div`
    padding: 40px;
    color: ${colors.textSecondary};
    text-align: center;
    background: ${colors.white};
`;
